import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
export var CoopInfoNameDescription = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement("div", { className: "flex flex--stacked flex--spaced" },
        React.createElement("div", { className: IdStyles.CoopInfoNameContainer + " " + IdStyles.TextBoldPrimary + " info-view_padding_small break-word" },
            React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" }, name)),
        React.createElement("div", { className: IdStyles.CoopInfoDescriptionContainer + " " + IdStyles.TextSmall + " info-view_padding_small break-word" },
            React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" }, description))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopInfoNameDescription.tsx
// module id = 2607
// module chunks = 3